import RefData from '../../../ref-data';
import sweepstake from './experience-sweepstake';
import quiz from './experience-quiz';
import content from './experience-content';
import game from './experience-game';
import reveal from './experience-reveal';

//use this place to add mechanic support to your workspace
export default {
  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.SWEEPSTAKECAPTION]: sweepstake.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.SWEEPSTAKEGIVEAWAY]: sweepstake.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.CONTENTPAGE]:  content.default,
  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.CONTENTBRAND]: content.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.SIGNUPREGISTRATION]: sweepstake.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZVS]: quiz.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZCATEGORYCHATBOT]: quiz.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZSCORE]: quiz.default, //WYN-6898 for quiz specific entries we need to support specific UI interfaces in the Workspace, such as Rewards and Entries for example. These option will show up as nav options in the top-down nav on the left side in the Workspace.

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZCATEGORY]: quiz.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZSHOPIFY]: quiz.default, //WYN-8668 shopify category quiz experience

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.QUIZADOBECOMMERCE]: quiz.default, //WYN-9082 adobe category quiz experience

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.SPINTHEWHEEL]: game.default,

  [RefData.Enum.SUBTYPE.CAMPAIGNOBJECT.MICROADVENTCALENDAR]: reveal.default,
};
